@if (investigation(); as inv) {
  <section
    class="investigation investigation--{{ inv.status }}"
    [class.investigation--reused]="inv.status === 'ready' && inv.reused"
    aria-labelledby="briefing-investigation-title"
    aria-live="polite">
    <span class="investigation__icon" aria-hidden="true">
      @if (isRunning()) {
        <app-cog-loading-spinner [size]="16" />
      } @else if (inv.status === 'ready') {
        <i class="pi" [class.pi-check]="!inv.reused" [class.pi-replay]="inv.reused"></i>
      } @else {
        <i class="pi pi-exclamation-triangle"></i>
      }
    </span>

    <div class="investigation__body">
      <p id="briefing-investigation-title" class="investigation__title">
        @switch (inv.status) {
          @case ('ready') {
            {{ inv.reused ? 'Investigação reaproveitada' : 'Investigação pronta' }}
          }
          @case ('failed') {
            Investigação não concluída
          }
          @default {
            Investigando a empresa
          }
        }
      </p>

      <p class="investigation__text">
        @switch (inv.status) {
          @case ('ready') {
            @if (inv.reused) {
              Da investigação de {{ inv.finishedAt | vaultDate }}, válida até
              {{ inv.validUntil | vaultDate }}.
            } @else {
              Feita em {{ inv.finishedAt | vaultDateTime }}; vale até
              {{ inv.validUntil | vaultDate }}.
            }
            @if (recommendation(); as label) {
              Recomendação: <strong>{{ label }}</strong
              >.
            }
          }
          @case ('failed') {
            {{
              inv.failureReason ||
                'A pesquisa não terminou. O briefing sai sem ela; use Refazer investigação para tentar de novo.'
            }}
          }
          @default {
            {{ runningText() }}
          }
        }
      </p>

      @if (isRunning()) {
        <!-- Etapas, atividade e tempo decorrido (card 3918). -->
        <app-briefing-investigation-progress
          [progress]="progress()"
          [catalog]="catalog()"
          [queued]="inv.status === 'queued'" />
      }

      @if (!isRunning()) {
        <!-- Botão desabilitado não recebe o hover: a dica do motivo fica no invólucro (como no PDF da aba). -->
        <span
          class="investigation__action"
          [pTooltip]="canRerun() ? '' : noRerunHint"
          tooltipPosition="bottom">
          <app-button
            [label]="'Refazer investigação'"
            [icon]="'refresh'"
            [theme]="'white'"
            [size]="'small'"
            [noMargin]="true"
            [isLoading]="rerunning()"
            [loadingText]="'Pedindo...'"
            [disabled]="!canRerun() || disabled() || rerunning()"
            [ariaLabel]="
              canRerun() ? 'Refazer investigação' : 'Refazer investigação. ' + noRerunHint
            "
            [title]="canRerun() ? 'Pesquisa a empresa de novo, mesmo dentro da validade' : ''"
            (sendButtonClick)="onRerun()" />
        </span>
      }
    </div>
  </section>
} @else if (selectedInRoadmap()) {
  <p class="investigation-hint">
    <i class="pi pi-search" aria-hidden="true"></i>
    Esta empresa ainda não foi investigada. A pesquisa começa junto com o briefing e leva alguns
    minutos.
  </p>
}
